import http from "../../http-common";
import apicall from "../../Utils/APICall";

class UsersDataService {
  getAll() {
    console.log(http.get("/users"));
    return http.get("/users");
  }

  get(id) {
    return http.get(`/users/${id}`);
  }

  create(data) {
    return apicall("users/register", "POST", data);
  }

  update(id, data) {
    return http.put(`/users/${id}`, data);
  }

  passwordChange(id, data) {
    return http.put(`/users/passwordchange/${id}`, data);
  }

  delete(id) {
    return http.delete(`/users/${id}`);
  }

  deleteAll() {
    return http.delete(`/users`);
  }

  resetPassword(data) {
    return apicall("users/reset-password-request", "POST", data);
  }

  findByUserNamePassword(data) {
    return apicall("users/authenticate", "POST", data);
    //return apicall(`/users/authenticate/?username=${username}&password=${password}`, "GET");
    /*mysqlConnection.query('SELECT * FROM products', (err, rows, fields) => {
      if (!err)
          res.send(rows);
      else
          console.log(err);
      })*/
  }

  findByUserName(username) {
    return http.get(`/users/findByUsername/${username}`);
  }

  findByEmailAddress(emailaddress) {
    return http.get(`/users?emailaddress=${emailaddress}`);
  }

  createUnit(data) {
    return apicall("/users/units/createUnit", "POST", data);
  }

  updateUnit(data) {
    return apicall("/users/units/updateUnit", "PUT", data);
  }
  
  deleteUnit(data) {
    return apicall("/users/units/deleteUnit", "DELETE", data);
  }
  
  getUnits() {
    return http.get("/users/units/getUnits");
  }  
  
  getUnitsByOption(data) {
    return apicall("/users/units/getUnitsByOption", "POST", data);
  }  

  createUser(data) {
    return apicall("/users/users/createUser", "POST", data);
  }

  updateUser(data) {
    return apicall("/users/users/updateUser", "PUT", data);
  }
  
  deleteUser(data) {
    return apicall("/users/users/deleteUser", "DELETE", data);
  }
  
  getUsers() {
    return http.get("/users/users/getUsers");
  }  
  
  getUsersByOption(data) {
    return apicall("/users/users/getUsersByOption", "POST", data);
  }  

  createQueryReceiver(data) {
    return apicall("/users/receivers/createQueryReceiver", "POST", data);
  }

  updateQueryReceiver(data) {
    return apicall("/users/receivers/updateQueryReceiver", "PUT", data);
  }
  
  deleteQueryReceiver(data) {
    return apicall("/users/receivers/deleteQueryReceiver", "DELETE", data);
  }
  
  getQueryReceivers() {
    return http.get("/users/receivers/getQueryReceivers");
  }  
  
  getQueryReceiversByOption(data) {
    return apicall("/users/receivers/getQueryReceiversByOption", "POST", data);
  }  

  createVoucherType(data) {
    return apicall("/users/vouchers/createVoucherType", "POST", data);
  }

  updateVoucherType(data) {
    return apicall("/users/vouchers/updateVoucherType", "PUT", data);
  }
  
  deleteVoucherType(data) {
    return apicall("/users/vouchers/deleteVoucherType", "DELETE", data);
  }
  
  getVoucherTypes() {
    return http.get("/users/vouchers/getVoucherTypes");
  }  
  
  getVoucherTypesByOption(data) {
    return apicall("/users/vouchers/getVoucherTypesByOption", "POST", data);
  }

  createVoucherCriteria(data) {
    return apicall("/users/voucherCriteria/createVoucherCriteria", "POST", data);
  }

  updateVoucherCriteria(data) {
    return apicall("/users/voucherCriteria/updateVoucherCriteria", "PUT", data);
  }
  
  deleteVoucherCriteria(data) {
    return apicall("/users/voucherCriteria/deleteVoucherCriteria", "DELETE", data);
  }
  
  getVoucherCriteria(data) {
    return apicall("/users/voucherCriteria/getVoucherCriteria", "POST", data);
  }  
  
  getVoucherCriteriaByOption(data) {
    return apicall("/users/voucherCriteria/getVoucherCriteriaByOption", "POST", data);
  }  

  createVoucherCharge(data) {
    return apicall("/users/voucherCharges/createVoucherCharge", "POST", data);
  }

  updateVoucherCharge(data) {
    return apicall("/users/voucherCharges/updateVoucherCharge", "PUT", data);
  }
  
  deleteVoucherCharge(data) {
    return apicall("/users/voucherCharges/deleteVoucherCharge", "DELETE", data);
  }
  
  getVoucherCharges(data) {
    return apicall("/users/voucherCharges/getVoucherCharges", "POST", data);
  }  
  
  getVoucherChargesByOption(data) {
    return apicall("/users/voucherCharges/getVoucherChargesByOption", "POST", data);
  }  

  createVoucherAudit(data) {
    return apicall("/users/vouchers/createVoucherAudit", "POST", data);
  }

  updateVoucherAudit(data) {
    return apicall("/users/vouchers/updateVoucherAudit", "PUT", data);
  }
  
  deleteVoucherAudit(data) {
    return apicall("/users/vouchers/deleteVoucherAudit", "DELETE", data);
  }
  
  getVoucherAudits(data) {
    return apicall("/users/vouchers/getVoucherAudits", "POST", data);
  }  
  
  getVoucherAuditsByStatus(data) {
    return apicall("/users/vouchers/getVoucherAuditsByStatus", "POST", data);
  }  
  
  getVoucherAuditsByOption(data) {
    return apicall("/users/vouchers/getVoucherAuditsByOption", "POST", data);
  }
  
  getVoucherAuditById(data) {
    return apicall("/users/vouchers/getVoucherAuditById", "POST", data);
  }
  
  getVoucherAuditByDate(data) {
    return apicall("/users/vouchers/getVoucherAuditByDate", "POST", data);
  }
  
  createVoucherAuditCriteria(data) {
    return apicall("/users/voucherAuditCriteria/createVoucherAuditCriteria", "POST", data);
  }

  updateVoucherAuditCriteria(data) {
    return apicall("/users/voucherAuditCriteria/updateVoucherAuditCriteria", "PUT", data);
  }
  
  deleteVoucherAuditCriteria(data) {
    return apicall("/users/voucherAuditCriteria/deleteVoucherAuditCriteria", "DELETE", data);
  }
  
  getVoucherAuditCriteria(data) {
    return apicall("/users/voucherAuditCriteria/getVoucherAuditCriteria", "POST", data);
  }  
  
  getVoucherAuditCriteriaByOption(data) {
    return apicall("/users/voucherAuditCriteria/getVoucherAuditCriteriaByOption", "POST", data);
  }  

  createVoucherAuditCharge(data) {
    return apicall("/users/voucherAuditCharges/createVoucherAuditCharge", "POST", data);
  }

  updateVoucherAuditCharge(data) {
    return apicall("/users/voucherAuditCharges/updateVoucherAuditCharge", "PUT", data);
  }
  
  deleteVoucherAuditCharge(data) {
    return apicall("/users/voucherAuditCharges/deleteVoucherAuditCharge", "DELETE", data);
  }
  
  getVoucherAuditCharges(data) {
    return apicall("/users/voucherAuditCharges/getVoucherAuditCharges", "POST", data);
  }  
  
  getVoucherAuditChargesByOption(data) {
    return apicall("/users/voucherAuditCharges/getVoucherAuditChargesByOption", "POST", data);
  }  

  createVoucherAuditDoc(data) {
    return apicall("/users/voucherAuditDocs/createVoucherAuditDoc", "POST", data);
  }

  updateVoucherAuditDoc(data) {
    return apicall("/users/voucherAuditDocs/updateVoucherAuditDoc", "PUT", data);
  }
  
  deleteVoucherAuditDoc(data) {
    return apicall("/users/voucherAuditDocs/deleteVoucherAuditDoc", "DELETE", data);
  }
  
  getVoucherAuditDocs(data) {
    return apicall("/users/voucherAuditDocs/getVoucherAuditDocs", "POST", data);
  } 

  getVoucherAuditDocsByOption(data) {
    return apicall("/users/voucherAuditDocs/getVoucherAuditDocsByOption", "POST", data);
  }  

  // getVoucherAuditDocsByOption(data) {
  //   return apicall("/users/voucherAuditDocs/getVoucherAuditDocsByOption", "POST", data);
  // }  
  
  createQueryForm(data) {
    return apicall("/users/queryForms/createQueryForm", "POST", data);
  }

  updateQueryForm(data) {
    return apicall("/users/queryForms/updateQueryForm", "PUT", data);
  }
  
  deleteQueryForm(data) {
    return apicall("/users/queryForms/deleteQueryForm", "DELETE", data);
  }
  
  getQueryForms(data) {
    return apicall("/users/queryForms/getQueryForms", "POST", data);
  }  
  
  getQueryFormsByOption(data) {
    return apicall("/users/queryForms/getQueryFormsByOption", "POST", data);
  }  

  getVoucherQueryById(data) {
    return apicall("/users/vouchers/getVoucherQueryById", "POST", data);
  }

  getDashBoardData(data) {
    return apicall("/users/vouchers/getDashBoardData", "POST", data);
  }
  
  getYears() {
    return http.get("/users/years/getYears");
  }  
  
  updateYears(data) {
    return apicall("/users/years/updateYears", "PUT", data);
  }  
  
  getStaffCategorys() {
    return http.get("/users/staffCategorys/getStaffCategorys");
  }  
  
  getStaffLevels() {
    return http.get("/users/staffLevels/getStaffLevels");
  }  
  
  getStaffSteps() {
    return http.get("/users/staffSteps/getStaffSteps");
  }  
  
  createSalaryScales(data) {
    return apicall("/users/salaryScales/createSalaryScale", "POST", data);
  }

  updateSalaryScales(data) {
    return apicall("/users/salaryScales/updateSalaryScale", "PUT", data);
  }
  
  deleteSalaryScales(data) {
    return apicall("/users/salaryScales/deleteSalaryScale", "DELETE", data);
  }
  
  getSalaryScales() {
    return http.get("/users/salaryScales/getSalaryScales");
  }  
  
  getSalaryScalesByYear(data) {
    return apicall("/users/salaryScales/getSalaryScalesByYear", "POST", data);
  }
  
  getSalaryScalesByYearAndCategory(data) {
   return apicall("/users/salaryScales/getSalaryScalesByYearAndCategory", "POST", data);
  }  
  
  createPaymentVoucher(data) {
    return apicall("/users/vouchers/createPaymentVoucher", "POST", data);
  }

  updatePaymentVoucher(data) {
    return apicall("/users/vouchers/updatePaymentVoucher", "PUT", data);
  }
  
  deletePaymentVoucher(data) {
    return apicall("/users/vouchers/deletePaymentVoucher", "DELETE", data);
  }
  
  getPaymentVouchers(data) {
    return apicall("/users/vouchers/getPaymentVouchers", "POST", data);
  }  
  
  getPaymentVouchersByStatus(data) {
    return apicall("/users/vouchers/getPaymentVouchersByStatus", "POST", data);
  }  
  
  getPaymentVouchersByOption(data) {
    return apicall("/users/vouchers/getPaymentVouchersByOption", "POST", data);
  }
  
  getPaymentVoucherById(data) {
    return apicall("/users/vouchers/getPaymentVoucherById", "POST", data);
  }
  
  getPaymentVoucherByDate(data) {
    return apicall("/users/vouchers/getPaymentVoucherByDate", "POST", data);
  }
  
  createPaymentVoucherDoc(data) {
    return apicall("/users/paymentVoucherDocs/createPaymentVoucherDoc", "POST", data);
  }

  updatePaymentVoucherDoc(data) {
    return apicall("/users/paymentVoucherDocs/updatePaymentVoucherDoc", "PUT", data);
  }
  
  deletePaymentVoucherDoc(data) {
    return apicall("/users/paymentVoucherDocs/deletePaymentVoucherDoc", "DELETE", data);
  }
  
  getPaymentVoucherDocs(data) {
    return apicall("/users/paymentVoucherDocs/getPaymentVoucherDocs", "POST", data);
  } 

  getPaymentVoucherDocsByOption(data) {
    return apicall("/users/paymentVoucherDocs/getPaymentVoucherDocsByOption", "POST", data);
  }  
  
  createStaffDetail(data) {
    return apicall("/users/variationAdvice/createStaffDetail", "POST", data);
  }

  getStaffDetails(data) {
    return apicall("/users/variationAdvice/getStaffDetails", "POST", data);
  }  
 
  createVariationAdvice(data) {
    return apicall("/users/variationAdvice/createVariationAdvice", "POST", data);
  }

  updateVariationAdvice(data) {
    return apicall("/users/variationAdvice/updateVariationAdvice", "PUT", data);
  }
  
  deleteVariationAdvice(data) {
    return apicall("/users/variationAdvice/deleteVariationAdvice", "DELETE", data);
  }
  
  getVariationAdvice(data) {
    return apicall("/users/variationAdvice/getVariationAdvice", "POST", data);
  }  
  
  getVariationAdvicesByStatus(data) {
    return apicall("/users/variationAdvice/getVariationAdvicesByStatus", "POST", data);
  }  
  
  getVariationAdvicesByOption(data) {
    return apicall("/users/variationAdvice/getVariationAdvicesByOption", "POST", data);
  }
  
  getVariationAdviceById(data) {
    return apicall("/users/variationAdvice/getVariationAdviceById", "POST", data);
  }
  
  getVariationAdviceByDate(data) {
    return apicall("/users/variationAdvice/getVariationAdviceByDate", "POST", data);
  }
  
  getOldVariationAdvice(data) {
    return apicall("/users/variationAdvice/getOldVariationAdvice", "POST", data);
  }
  
  getVisitsByDate(data) {
    return apicall("/users/visitor_register/getVisitsByDate", "POST", data);
  }  
  getStaffs() {
    return http.get("/users/staff/getStaffs");
  }  

}

export default new UsersDataService();